import Utility from "./utility";
import amplitude from "amplitude-js";
import amplitudeKeys from "../config/amplitudeKeys";
import { keyMapsGetter } from "./storeKeys";
import store from "../store/index";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";

const getLinkRewrite = () => {
  let linkRewrite = window._siteProps_?.link_rewrite || '';
  return linkRewrite !== '/';
};

if(getLinkRewrite()) {
  amplitude
    ?.getInstance()
    .init(amplitudeKeys.amplitudeApiKey, null, amplitudeKeys.amplitudeConfigObj);
}

const setEvents = (type, name, eventObj) => {
  if (getLinkRewrite()) {
    if (type == "amplitude") {
      loadAmplitudeEvents(name, eventObj);
    } else if (type == "moengage") {
      loadMoengageEvents(name, eventObj);
    }
  }
};

const loadAmplitudeEvents = (event, eventProperties) => {
  eventProperties = updateEventsIfSeparateMenu(eventProperties);
  eventProperties.Events_time_stamp = new Date().getTime(); //timeStamp in every event

  if (
    Object.keys(store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS])?.length &&
    window.amplitudeEventsTemp?.length == 0
  ) {
    amplitude?.getInstance().logEvent(event, eventProperties);
  } else {
    if (window.amplitudeEventsTemp?.length > 0) {
      window.amplitudeEventsTemp.push({
        event: event,
        eventProperties: eventProperties,
      });
    } else {
      window.amplitudeEventsTemp = [];
      window.amplitudeEventsTemp.push({
        event: event,
        eventProperties: eventProperties,
      });
    }
  }
};

const loadAmplitudeUnsentEvents = (test) => {
  amplitude?.getInstance().setUserProperties({
    ...(amplitudeKeys?.getAmpUserProperties() || {}),
    [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
      Utility.tryJsonParse(sessionStorage.VWO_PWA_V2_VARIATIONS)?.[
        VWO_NEXTGEN_HOMEPAGE_EXPERIMENT
      ] || "N/A",
  });

  window.amplitudeEventsTemp?.forEach((amplitudeEventTemp) => {
    amplitudeEventTemp = {
      ...amplitudeEventTemp,
      eventProperties: updateEventsIfSeparateMenu(
        amplitudeEventTemp.eventProperties
      ),
    };
    amplitude
      ?.getInstance()
      .logEvent(amplitudeEventTemp.event, amplitudeEventTemp.eventProperties);
  });
  window.amplitudeEventsTemp = [];
};

const updateAmplitudeUserProperties = (properties = {}) => {
  amplitude?.getInstance().setUserProperties(properties);
};

const loadMoengageEvents = (eventType, payload) => {
  if (window.Moengage !== undefined) {
    window.Moengage.track_event(eventType, payload);
  }
};

const updateEventsIfSeparateMenu = (eventObj) => {
  if (Utility.isSeparateMenuVariant()) {
    if (
      eventObj.Page_Name === "nextgen home page" ||
      eventObj.screenName === "nextgen home page"
    ) {
      eventObj["Page_Name"] = PageNames.NEXTGEN_MENUPAGE;
      eventObj["screenName"] = PageNames.NEXTGEN_MENUPAGE;
    } else if (
      (eventObj.Page_Name === PageNames.NEXTGEN_SEARCHPAGE ||
        eventObj.Page_Name === PageNames.NEXTGEN_CUSTOISATIONPAGE) &&
      (eventObj.previousScreenname === PageNames.NEXTGEN_HOMEPAGE ||
        eventObj.Previous_page === PageNames.NEXTGEN_HOMEPAGE)
    ) {
      eventObj["previousScreenname"] = PageNames.NEXTGEN_MENUPAGE;
      eventObj["Previous_page"] = PageNames.NEXTGEN_MENUPAGE;
    }
  }
  return eventObj;
};

export default setEvents;

export { 
  loadAmplitudeUnsentEvents, 
  updateAmplitudeUserProperties,
};
